export default function convert(old, opts) {
  const {
    settingsRoot,
    converters,
    usedSettingsPath,
    getSettingsAt
  } = opts;
  let nMdl, id;
  if (old === 'dashboard') {
    // This is a top level dashboard data viewer
    const settings = getSettingsAt(`${settingsRoot}/dashboard`);
    usedSettingsPath.add(`${settingsRoot}/dashboard`);
    nMdl = {
      ...settings
    };
  } else if (old && old.type === 'uiDashboardGrid') {
    // This is a grid. All the data is here
    usedSettingsPath.add(`${settingsRoot}/dashboard`);
    nMdl = {
      ...old
    };
  }
  const {
    cards
  } = nMdl;
  if (!Array.isArray(cards)) {
    nMdl.cards = [];
  } else {
    nMdl.cards = cards.map(c => {
      const nOpts = {
        ...opts,
        settingsRoot: id ? `${settingsRoot}.${id}` : settingsRoot
      };
      if (converters.get(c.type)) {
        return converters.create(c)(c, nOpts);
      }
      return null;
    }).filter(c => c != null);
  }
  return nMdl;
}
convert.TYPE = 'dashboard';
convert.GRID_TYPE = 'uiDashboardGrid';